@if (hasPagedDoc) {
  <button
    type="button"
    class="viewer-controller-icon-btn viewer-slider-toggle-btn"
    [class.active]="!isPdfSliderCollapsed"
    [attr.data-tooltip]="!isPdfSliderCollapsed ? 'Exit Thumbs Panel' : 'Thumbs Panel'"
    aria-label="Thumbs Panel"
    (click)="togglePdfSlider()">
    <!-- Mock icon (replace later) -->
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        class="icon-g"
        d="M15.6562 0C16.442 0.00023564 17.0789 0.63714 17.0791 1.42285V12.8096L17.0713 12.9541C17.0034 13.6241 16.4708 14.1567 15.8008 14.2246L15.6562 14.2324H1.42285L1.27832 14.2246C0.608286 14.1567 0.0757426 13.6241 0.0078125 12.9541L0 12.8096V1.42285C0.000218568 0.63713 0.63713 0.000218408 1.42285 0H15.6562ZM1.42285 12.8096H4.82715V1.42285H1.42285V12.8096ZM6.25 12.8096H15.6562V1.42285H6.25V12.8096Z"
        fill="currentColor" />
    </svg>
  </button>
}
